import { render, staticRenderFns } from "./AttachEmailModal.vue?vue&type=template&id=52ff15e0&scoped=true&"
import script from "./AttachEmailModal.vue?vue&type=script&lang=js&"
export * from "./AttachEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ff15e0",
  null
  
)

export default component.exports